import React, { useEffect, useState } from "react";
import T from "prop-types";
import { Row, Col } from "react-bootstrap";
import { Stat } from "MODULES/shared/components";
import numeral from "numeral";
import api from "APP_ROOT/api";

function Count({ data, dateLabel, type }) {
  return (
    <Stat
      label={`# Shipments - ${dateLabel}`}
      value={numeral(data[type]).format("(0,0)")}
    />
  );
}

Count.propTypes = {
  data: T.shape({}),
  dateLabel: T.string,
  type: T.string
};

function Stats() {
  const [stats, setStats] = useState();

  useEffect(() => {
    api.shipments.stats().then(resp => {
      setStats(resp.data);
    });
  }, []);

  if (!stats) return null;

  return (
    <Row>
      <Col md={3}>
        <Count dateLabel="YTD" data={stats} type="year_to_date" />
      </Col>
      <Col md={3}>
        <Count dateLabel="Today" data={stats} type="today" />
      </Col>
      <Col md={3}>
        <Count dateLabel="Current Month" data={stats} type="current_month" />
      </Col>
      <Col md={3}>
        <Count dateLabel="Last 30 Days" data={stats} type="last_30_days" />
      </Col>
    </Row>
  );
}

Stats.propTypes = {};

export default Stats;



// WEBPACK FOOTER //
// ./app/modules/OutgoingShipments/components/Search/Stats.jsx